import { ListMonitoringEntriesQueryControllerListCheckSlug } from "@/generated/model/listMonitoringEntriesQueryControllerListCheckSlug";

/**
 * Mirrors the server's fire-alarm-test config. The result field must match its
 * pass/fail rule, which fails closed: a mismatch would fail every test. The
 * field is seed data with no generated enum, so this is its one definition.
 */
export const FIRE_ALARM_TEST_LOG_TYPE_SLUG =
  ListMonitoringEntriesQueryControllerListCheckSlug["fire-alarm-weekly-test"];
export const FIRE_ALARM_TEST_RESULT_FIELD = "alarmSounded";

/**
 * Mirrors the server's fire-door-inspection config. Each inspection names one
 * registered door (NAU-441); the result key predates that and is kept so earlier
 * inspections read the same way.
 */
export const FIRE_DOOR_INSPECTION_LOG_TYPE_SLUG =
  ListMonitoringEntriesQueryControllerListCheckSlug["fire-door-inspection"];
export const FIRE_DOOR_INSPECTION_RESULT_FIELD = "allDoorsOk";

export function isFireDoorInspectionPass(
  data: Record<string, unknown> | null | undefined,
): boolean {
  return data?.[FIRE_DOOR_INSPECTION_RESULT_FIELD] === true;
}

/** "Door (Room)", or just the door — the same label Monitoring and the export use. */
export function fireDoorLabel(door: {
  name: string;
  room?: { name: string } | null;
}): string {
  if (!door.room) return door.name;
  return `${door.name} (${door.room.name})`;
}
